import { TableCell, TableCellProps } from '@mui/material';
import React, { ReactNode } from 'react';

export type ExTableCellProps = TableCellProps & {
  width?: number;
  minWidth?: number;
  open?: boolean;
  children?: ReactNode;
};

export const ExTableCell: React.FC<ExTableCellProps> = ({
  width,
  open = true,
  minWidth,
  style,
  children,
  ...rest
}: ExTableCellProps) => {
  const getStyle = (): React.CSSProperties => {
    const styles: React.CSSProperties = {};
    if (width) {
      styles['width'] = width;
      styles['minWidth'] = width;
    }

    if (minWidth) {
      styles['minWidth'] = minWidth;
    }

    if (open) {
      styles['display'] = 'table-cell';
    } else {
      styles['display'] = 'none';
    }
    return styles;
  };

  return (
    <TableCell {...rest} style={{ ...style, ...getStyle() }} padding={open ? 'normal' : 'none'}>
      {children}
    </TableCell>
  );
};

export default ExTableCell;
